import { useQuery } from '@tanstack/react-query'

import { getPriceSummary, getReceiptItemCategories, searchReceiptItems } from '@/api/services/receipt'
import type { PriceSummaryQuery, SearchReceiptItemsQuery } from '@/api/types/receipt'

export const receiptItemKeys = {
  all: ['receipt-items'] as const,
  search: (query: SearchReceiptItemsQuery) => ['receipt-items', 'search', query] as const,
  priceSummary: (query: PriceSummaryQuery) => ['receipt-items', 'price-summary', query] as const,
  categories: ['receipt-items', 'categories'] as const,
}

export const useReceiptItemSearch = (query: SearchReceiptItemsQuery, options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: receiptItemKeys.search(query),
    queryFn: ({ signal }) => searchReceiptItems(query, signal),
    enabled: options?.enabled ?? true,
  })

/** 検索語が空のときは集計する意味が無いので、呼び出し側で enabled を切ること。 */
export const usePriceSummary = (query: PriceSummaryQuery, options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: receiptItemKeys.priceSummary(query),
    queryFn: ({ signal }) => getPriceSummary(query, signal),
    enabled: options?.enabled ?? true,
  })

export const useReceiptItemCategories = () =>
  useQuery({
    queryKey: receiptItemKeys.categories,
    queryFn: ({ signal }) => getReceiptItemCategories(signal),
    staleTime: 1000 * 60 * 10,
  })
